import React from 'react';
const FinalNet = ({ netIndex, images, widthMM, heightMM, multiplier }) => {
    return (React.createElement("div", { className: "hg-final-net", "data-final-net": netIndex, style: { width: widthMM * multiplier, height: heightMM * multiplier } },
        React.createElement("div", { className: "hg-final-net__wrapper" }, images.map((capturedImage, index) => {
            let styles = {
                width: capturedImage.width * multiplier + 'px',
                height: capturedImage.height * multiplier + 'px',
                top: capturedImage.top * multiplier + 'px',
                left: capturedImage.left * multiplier + 'px',
            };
            if (Number(capturedImage.rotation) == 90) {
                styles = Object.assign(Object.assign({}, styles), { 
                    // @ts-ignore
                    transform: `rotate(${capturedImage.rotation}deg) translate(0%, -100%)`, transformOrigin: 'top left' });
            }
            else if (Number(capturedImage.rotation) == 270) {
                styles = Object.assign(Object.assign({}, styles), { 
                    // @ts-ignore
                    transform: `rotate(${capturedImage.rotation}deg) translate(-100%, 0%)`, transformOrigin: 'top left' });
            }
            return (React.createElement("img", { className: "hg-final-net__side-image", src: capturedImage.dataUrl, key: index, style: styles }));
        }))));
};
export default FinalNet;
